// Auto-generated from Java REST API
/* eslint-disable no-useless-escape */

export const Constants = {
  ADDITIONAL_INFORMATION_LENGTH_MAX: 500,
  ADDITIONAL_INFORMATION_LENGTH_MIN: 1,
  BANKNAME_LENGTH_MAX: 100,
  BANKNAME_LENGTH_MIN: 3,
  BIC_LENGTH_MAX: 11,
  BIC_LENGTH_MIN: 8,
  BOXHUB_NUMBER_LENGTH_MAX: 50,
  BOXHUB_NUMBER_LENGTH_MIN: 1,
  BUNDLES_PER_PACKAGE_MAX: 50,
  BUNDLES_PER_PACKAGE_MIN: 0,
  CANCELLATION_REASON_LENGTH_MAX: 1000,
  CARTON_GRADE_CODE_LENGTH_MAX: 15,
  CARTON_GRADE_CODE_LENGTH_MIN: 4,
  CARTON_GRADE_EDGE_CRUSH_TEST_MAX: 200.00,
  CARTON_GRADE_EDGE_CRUSH_TEST_MIN: 1.00,
  CARTON_GRADE_FLUTE1_LENGTH_MAX: 12,
  CARTON_GRADE_FLUTE1_LENGTH_MIN: 3,
  CARTON_GRADE_FLUTE2_LENGTH_MAX: 12,
  CARTON_GRADE_FLUTE2_LENGTH_MIN: 0,
  CARTON_GRADE_FLUTE3_LENGTH_MAX: 13,
  CARTON_GRADE_FLUTE3_LENGTH_MIN: 0,
  CARTON_GRADE_FLUTE_LENGTH_MAX: 8,
  CARTON_GRADE_FLUTE_LENGTH_MIN: 1,
  CARTON_GRADE_INNER_LINER_LENGTH_MAX: 12,
  CARTON_GRADE_INNER_LINER_LENGTH_MIN: 3,
  CARTON_GRADE_LINER1_LENGTH_MAX: 12,
  CARTON_GRADE_LINER1_LENGTH_MIN: 0,
  CARTON_GRADE_LINER2_LENGTH_MAX: 12,
  CARTON_GRADE_LINER2_LENGTH_MIN: 0,
  CARTON_GRADE_OUTER_LINER_LENGTH_MAX: 12,
  CARTON_GRADE_OUTER_LINER_LENGTH_MIN: 3,
  CARTON_GRADE_THICKNESS_MAX: 250.00,
  CARTON_GRADE_THICKNESS_MIN: 0.01,
  CARTON_GRADE_WEIGHT_MAX: 1000.00,
  CARTON_GRADE_WEIGHT_MIN: 0.01,
  CHAT_ATTACHMENTS_PER_MESSAGE_MAX: 5,
  CHAT_ATTACHMENT_SIZE_MAX_BYTES: 10485760,
  CHAT_MESSAGE_BODY_LENGTH_MAX: 4000,
  CITY_LENGTH_MAX: 100,
  CITY_LENGTH_MIN: 1,
  CLICHE_COSTS_PRICE_MAX: 1000000,
  CLICHE_COSTS_PRICE_MIN: 0,
  COMMERCIAL_REGISTER_NUMBER_LENGTH_MAX: 20,
  COMMERCIAL_REGISTER_NUMBER_LENGTH_MIN: 4,
  COMPANY_NAME_LENGTH_MAX: 150,
  COMPANY_NAME_LENGTH_MIN: 2,
  CUSTOMER_REFERENCE_NUMBER_LENGTH_MAX: 50,
  CUSTOMER_REFERENCE_NUMBER_LENGTH_MIN: 1,
  DANGEROUS_GOODS_NOTES_LENGTH_MAX: 1024,
  DELIVERY_DATE_REJECTION_REASON_LENGTH_MAX: 1000,
  DELIVERY_INSTRUCTION_AND_ADVICE_NOTE_LENGTH_MAX: 100,
  DOCUMENTS_SIZE_MAX: 10,
  DOCUMENTS_TYPE_LENGTH_MAX: 5,
  EMAIL_LENGTH_MAX: 320,
  EMAIL_LENGTH_MIN: 4,
  ENV_DEVELOPER: "developer",
  ENV_DEVELOPMENT: "dev",
  ENV_PRODUCTION: "prod",
  ENV_STAGING: "staging",
  ERP_MANUFACTURER_LENGTH_MAX: 200,
  ERP_MANUFACTURER_LENGTH_MIN: 1,
  ERP_SOFTWARE_NAME_LENGTH_MAX: 200,
  ERP_SOFTWARE_NAME_LENGTH_MIN: 1,
  ERP_SOFTWARE_VERSION_LENGTH_MAX: 200,
  ERP_SOFTWARE_VERSION_LENGTH_MIN: 1,
  ERROR_MESSAGE_LENGTH: 1000,
  FEEDBACK_LENGTH_MAX: 1000,
  FEEDBACK_LENGTH_MIN: 1,
  FEEDBACK_REASON_FREE_TEXT_LENGTH_MAX: 1000,
  FEFCO_CODE_LENGTH_MAX: 50,
  FEFCO_CODE_LENGTH_MIN: 1,
  FILENAME_LENGTH_MAX: 200,
  FILENAME_LENGTH_MIN: 2,
  FIRSTNAME_LENGTH_MAX: 50,
  FIRSTNAME_LENGTH_MIN: 2,
  HOUSE_NUMBER_LENGTH_MAX: 20,
  HOUSE_NUMBER_LENGTH_MIN: 1,
  I18N_ENTRY_VALUE_LENGTH_MAX: 32767,
  I18N_EXPORT_MAX_KEYS: 5000,
  I18N_KEY_LENGTH_MAX: 512,
  IBAN_LENGTH_MAX: 34,
  IBAN_LENGTH_MIN: 3,
  INTERNAL_CONFIRMATION_REASON_LENGTH_MAX: 1000,
  INTERNAL_CONFIRMATION_REASON_LENGTH_MIN: 1,
  INTERNAL_DIMENSION_MAX: 5000,
  INTERNAL_DIMENSION_MIN: 1,
  LASTNAME_LENGTH_MAX: 100,
  LASTNAME_LENGTH_MIN: 2,
  LATITUDE_MAX: 90,
  LATITUDE_MIN: "-90",
  LONGITUDE_MAX: 180,
  LONGITUDE_MIN: "-180",
  MAX_DISTANCE_KM_MAX: 20000,
  MAX_DISTANCE_KM_MIN: 1,
  MAX_IDENTIFIER_LENGTH: 50,
  MAX_UPLOAD_FILES_PER_REQUEST: 5,
  MIN_UPLOAD_FILES_PER_REQUEST: 1,
  NET_PRICE_PER_1000_MAX: 10000000,
  NET_PRICE_PER_1000_MIN: 0.01,
  NUMBER_OF_COLORS_MAX: 8,
  NUMBER_OF_COLORS_MIN: 0,
  OFFICE_HOURS_LENGTH_MAX: 250,
  OFFICE_HOURS_LENGTH_MIN: 1,
  ORDER_DOCUMENT_DELETE_BATCH_SIZE_MAX: 100,
  ORDER_NUMBER_LENGTH_MAX: 50,
  ORDER_SEARCH_PAGE_DEFAULT: 0,
  ORDER_SEARCH_SIZE_DEFAULT: 25,
  ORDER_SEARCH_SIZE_MAX: 50,
  ORDER_SEARCH_SIZE_MIN: 1,
  ORDER_SEARCH_SIZE_OPTIONS: "10,25,50",
  ORDER_SEARCH_TEXT_LENGTH_MAX: 150,
  PALLETIZING_NOTES_LENGTH_MAX: 1024,
  PALLET_HEIGHT_DEFAULT: 1800,
  PALLET_HEIGHT_MAX: 2400,
  PALLET_HEIGHT_MIN: 150,
  PALLET_OVERHANG_DEFAULT: 50,
  PALLET_OVERHANG_MAX: 500,
  PALLET_OVERHANG_MIN: 0,
  PASSWORD_LENGTH_MAX: 50,
  PASSWORD_LENGTH_MIN: 12,
  PAYMENT_TERMS_LENGTH_MAX: 512,
  PAYMENT_TERMS_LENGTH_MIN: 1,
  PHONE_NUMBER_LENGTH_MAX: 20,
  PHONE_NUMBER_LENGTH_MIN: 6,
  PLANT_LOCATION_LENGTH: 100,
  PLANT_MATERIAL_PRODUCTION_PRIORITY_CODE_LENGTH: 1,
  PLANT_NAME_LENGTH: 10,
  PRICE_PER_PALLET_MAX: 99.99,
  PRICE_PER_PALLET_MIN: 0.00,
  PRINT_IMAGE_NOTES_LENGTH_MAX: 1024,
  QUANTITY_MAX: 10000000,
  QUANTITY_MIN: 1,
  QUANTITY_OPTIONS_LENGTH_MAX: 5,
  QUANTITY_OPTIONS_LENGTH_MIN: 1,
  QUANTITY_PER_PALLET_MAX: 99999,
  QUANTITY_PER_PALLET_MIN: 0,
  REASON_LENGTH_MAX: 500,
  REASON_LENGTH_MIN: 1,
  REJECTION_REASON_LENGTH_MAX: 1000,
  REJECTION_REASON_LENGTH_MIN: 1,
  REQUEST_ADDITIONAL_INFORMATION_LENGTH_MAX: 4000,
  REQUEST_ADDITIONAL_INFORMATION_LENGTH_MIN: 1,
  REQUEST_RECIPIENT_SELECTION_COMPANY_IDS_MAX: 1000,
  REQUEST_SEARCH_DISTANCE_KM_MAX: 20000,
  REQUEST_SEARCH_NET_PRICE_INTEGER_DIGITS_MAX: 8,
  REQUEST_SEARCH_NET_PRICE_MAX: 10000000,
  REQUEST_SEARCH_PAGE_DEFAULT: 0,
  REQUEST_SEARCH_PRICE_FRACTION_DIGITS_MAX: 2,
  REQUEST_SEARCH_SIZE_DEFAULT: 25,
  REQUEST_SEARCH_SIZE_MAX: 50,
  REQUEST_SEARCH_SIZE_MIN: 1,
  REQUEST_SEARCH_SIZE_OPTIONS: "10,25,50",
  REQUEST_SEARCH_TEXT_LENGTH_MAX: 150,
  REQUEST_SEARCH_TOTAL_PRICE_INTEGER_DIGITS_MAX: 12,
  REQUEST_SEARCH_TOTAL_PRICE_MAX: 100000000000,
  SEARCH_SELECTION_MAX: 500,
  SERIES_TOTAL_QUANTITY_MAX: 100000000,
  SERIES_TOTAL_QUANTITY_MIN: 1,
  SETTINGS_VALUE_LENGTH_MAX: 32768,
  STREET_LENGTH_MAX: 150,
  STREET_LENGTH_MIN: 1,
  TENANT_NAME_LENGTH_MAX: 150,
  TENANT_NAME_LENGTH_MIN: 2,
  TOOLING_COSTS_PRICE_MAX: 1000000,
  TOOLING_COSTS_PRICE_MIN: 0,
  VAT_ID_LENGTH_MAX: 20,
  VAT_ID_LENGTH_MIN: 8,
  WEBSITE_LENGTH_MAX: 256,
  WEBSITE_LENGTH_MIN: 3,
  ZIP_LENGTH_MAX: 10,
  ZIP_LENGTH_MIN: 3,
} as const;
